import type { JSX } from 'react';
import { useState } from 'react';

import { ChevronDown, ChevronRight } from 'lucide-react';

import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';

import type { AgentTestRun } from '../../model/run';
import RunsTable from './RunsTable';

interface AutomaticRunsTableProps {
  runs: AgentTestRun[];
  onViewResults: (run: AgentTestRun) => void;
}

const AutomaticRunsTable = ({ runs, onViewResults }: AutomaticRunsTableProps): JSX.Element | null => {
  const [historyOpen, setHistoryOpen] = useState(false);

  if (runs.length === 0) return null;

  const visibleRuns = historyOpen ? runs : runs.slice(0, 1);
  const historyCount = runs.length - 1;

  return (
    <div className="flex flex-col gap-2">
      <div className={cn(historyOpen && 'max-h-[320px] overflow-y-auto pr-1')}>
        <RunsTable runs={visibleRuns} onViewResults={onViewResults} />
      </div>
      {historyCount > 0 ? (
        <Button
          type="button"
          variant="ghost"
          size="sm"
          className="w-fit text-text-muted"
          onClick={() => setHistoryOpen((open) => !open)}
        >
          {historyOpen ? (
            <ChevronDown className="size-4" aria-hidden />
          ) : (
            <ChevronRight className="size-4" aria-hidden />
          )}
          {historyOpen ? 'Ocultar historial' : `Ver historial (${historyCount})`}
        </Button>
      ) : null}
    </div>
  );
};

export default AutomaticRunsTable;
